<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div class="flex justify-content-between" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-users title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.users' | transloco}}</p>
            <p>
              {{(mode == 'create' ? 'misc.creation.permission' : 'misc.edition.permission') | transloco | capitalize}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <ng-container *ngIf="!isPermissionLoading && permissionForm">
        <form [formGroup]="permissionForm">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="name">{{'attribute.name' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="name" id="name" pInputText type="text">
              </div>
              <app-validation-errors [control]="permissionForm.get('name')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="description">{{'attribute.description' | transloco}}:</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="description" id="description" pInputText type="text">
              </div>
              <app-validation-errors [control]="permissionForm.get('description')"></app-validation-errors>
            </div>
          </div>
        </form>
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <p-button [label]="'common.cancel' | transloco" (onClick)="cancel()" styleClass="p-button-danger"
                  iconPos="right"></p-button>
                <p-button [label]="(mode == 'create' ? 'common.create' : 'common.save') | transloco"
                  [disabled]="!permissionForm?.valid" [loading]="persistingChanges" (onClick)="persistPermissionData()"
                  styleClass="p-button-primary"></p-button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isPermissionLoading || permissionForm == null">
        <div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="name">{{'attribute.name' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="description">{{'attribute.description' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <div class="w-7rem">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
                <div class="w-7rem">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
